import React from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Alert, Button, Space } from 'antd';
import { SwapOutlined, UserOutlined } from '@ant-design/icons';
import { useStores } from '../stores';

const ImpersonationBanner = observer(() => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { authStore } = useStores();

  if (!authStore.isImpersonating) {
    return null;
  }

  const handleSwitchBack = () => {
    authStore.switchBack();
    navigate('/admin/users');
  };

  return (
    <Alert
      message={
        <Space>
          <UserOutlined />
          <span>
            {t('admin.impersonation.banner', {
              email: authStore.user?.email,
              name: `${authStore.user?.first_name || ''} ${authStore.user?.last_name || ''}`.trim() || authStore.user?.email
            })}
          </span>
        </Space>
      }
      type="warning"
      banner
      action={
        <Button
          size="small"
          type="primary"
          icon={<SwapOutlined />}
          onClick={handleSwitchBack}
        >
          {t('admin.impersonation.switchBack')}
        </Button>
      }
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1001,
        textAlign: 'center',
      }}
    />
  );
});

export default ImpersonationBanner;
